import React from "react";
import { BrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { Provider } from "react-redux";
import AppRoutes from "./routes";
import AuthProvider from "./context/AuthContext";
import store from "./redux/store";
import PageLoading from "./components/Utils/PageLoading";
import ErrorBanner from "./components/Utils/ErrorBanner";

const AppContent = () => {
  const pageLoading = useSelector((state) => state.app.pageLoading);

  return (
    <AuthProvider>
      <BrowserRouter>
        {pageLoading && <PageLoading />}
        <ErrorBanner /> {/* Display error banner */}
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
};

const App = () => (
  <Provider store={store}>
    <AppContent />
  </Provider>
);

export default App;
